import { TablePagination } from '@mui/material';
import React, { useEffect, useState } from 'react'

export default function Pagination({ allData, currentPage, paginate,itemPerPage }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);


    const handleChangePage = (event, newPage) => {
        paginate(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    useEffect(() => {
        setPage(currentPage)
        setRowsPerPage(itemPerPage)
    }, [paginate])
    return (
        <>
            <TablePagination
                component="div"
                rowsPerPageOptions={[5, 10, 15, 20, 25]}
                count={allData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    )
}
